import React from "react"
import ReactDOM from "react-dom"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

//Below code is updated in react 18 but it doesn't worked in redux.
// may be we forgot something....¯\_(ツ)_/¯

// import React from "react"
// import ReactDOM from "react-dom/client"
// import "./index.css"
// import App from "./App"
// import reportWebVitals from "./reportWebVitals"

// const root = ReactDOM.createRoot(document.getElementById("root"))
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// )

// reportWebVitals()
